export default {
	// Loader will auto prefix common. key to message
	"common.application.title" : "DECK" ,
	"common.application.title.second" : "Drone Service Management" ,
	"common.password.pattern" : "Password should have 6 - 40 characters and have at least 1 number" ,
	"common.privacy.policy" : "Privacy Policy",
};
